<div *ngIf="passengers" class="container">
    <div class="row">
        <div class="col-xs-12 u-pl-none u-pr-none">
            <ng-react *ngIf="showModalTravel" [component]="ModalTravelRequirements" [props]="modalTravelRequirementsProps"></ng-react>
            <ng-react [component]="passengerCheckInUnavailableModal" [props]="unavailableModalProps"></ng-react>
            <ng-react [component]="passengerDataCheckModal" [props]="dataCheckModalProps"></ng-react>
            <h1 class="page-title">{{ "APIS_PAGE_TITLE" | translate }}</h1>
            <div *ngIf="showAlertInfo">
                <ng-react [component]="AlertAutoCheck"></ng-react>
            </div>
            <ib-overlay [isOpen]="overlayProps.isOpen" [messageKey]="overlayProps.messageKey" [status]="overlayProps.status">
                <div *ngFor="let passenger of passengersNOAPIS; let i = index">
                    <ib-accordion-container
                        [attr.id]="'passengerNOAPI' + passenger.id || '0'"
                        [passengerName]="passenger.fullName"
                        [passengerStatus]="passenger.status"
                        [isOpen]="false"
                        [isNOAPI]="passenger.isNOAPI"
                    />
                </div>
                <div *ngFor="let passenger of passengers; let i = index">
                    <ib-accordion-container
                        [attr.id]="'passenger' + passenger.id || '0'"
                        [passengerName]="getFullName(passenger)"
                        [passengerStatus]="passenger.formStatus"
                        [isOpen]="openAccordionIndex === i"
                        (toggle)="toggleAccordion(i)"
                    >
                        <ib-checkin-form-apis
                            [passenger]="passenger"
                            [isMultiPassengers]="isMultiPassengers"
                            [index]="i"
                            (passengerStatusChange)="passengerStatusChange($event)"
                            (updateOverlayStatus)="updateOverlayStatus($event)"
                            (showModalCheckinNotAvailable)="showModalCheckinNotAvailable($event)"
                        ></ib-checkin-form-apis>
                    </ib-accordion-container>
                </div>
            </ib-overlay>
            <div class="button-container" *ngIf="countPassengers.isMulti">
                <ng-react [component]="ButtonContinue" [props]="buttonContinueProps" class="apis-form-button"></ng-react>
            </div>
        </div>
    </div>
</div>
